import type { FieldInputConfigProtocol } from '@lighthouse/core'

import type { DesignSettingSwitch } from '../DesignSetting'
import type { InteractionSettingSwitch } from '../types'

export type GetFieldBlockLimitParams = {
    isPersonTag?: boolean
    isSlider?: boolean
    isFileUploaded?: boolean
    isSelectField?: boolean
    isSelectTag?: boolean
    relativeSelectShowMode?: 'input' | 'checkbox' | 'tag'
}

// 获取字段block 样式设计配置属性
export const getFieldBlockStyleLimit = (
    type: FieldInputConfigProtocol['inputType'],
    params?: GetFieldBlockLimitParams
): Partial<DesignSettingSwitch> | undefined => {
    switch (type) {
        case 'text':
        case 'phoneNumber':
        case 'email':
        case 'url':
        case 'number':
        case 'cascade':
        case 'date': {
            return {
                enableTheme: true,
                enableRadius: true,
                enableLabelColor: true,
                enableColor: true,
                enableIconColor: true,
                enablePlaceholderColor: true,
                enableBackground: true,
                enableBorder: true,
                enableShadow: true
            }
        }
        case 'relativeSelect': {
            if (!params?.isSelectField) {
                if (params?.relativeSelectShowMode === 'input') {
                    if (params?.isSelectTag) {
                        return {
                            enableColor: true,
                            enableIconColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        }
                    }
                    return {
                        enableTheme: true,
                        enableRadius: true,
                        enableLabelColor: true,
                        enableIconColor: true,
                        enablePlaceholderColor: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    }
                }
                if (params?.relativeSelectShowMode === 'tag') {
                    return {
                        enableTheme: true,
                        enableRadius: true,
                        enableLabelColor: true,
                        enableColor: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    }
                }
                if (params?.relativeSelectShowMode === 'checkbox') {
                    return {
                        enableTheme: true,
                        enableLabelColor: true,
                        enableColor: true,
                        enableBackground: true,
                        enableBorder: true
                    }
                }
                return undefined
            }
            if (params?.relativeSelectShowMode === 'input') {
                return {
                    enableTheme: true,
                    enableRadius: true,
                    enableLabelColor: true,
                    enableIconColor: true,
                    enablePlaceholderColor: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }
            if (params?.relativeSelectShowMode === 'tag') {
                return {
                    enableTheme: true,
                    enableLabelColor: true
                }
            }
            if (params?.relativeSelectShowMode === 'checkbox') {
                return {
                    enableTheme: true,
                    enableLabelColor: true,
                    enableBackground: true,
                    enableBorder: true
                }
            }
            return undefined
        }
        case 'person': {
            if (params?.isPersonTag) {
                return {
                    enableColor: true,
                    enableIconColor: true
                }
            }
            return {
                enableTheme: true,
                enableRadius: true,
                enableLabelColor: true,
                enableIconColor: true,
                enablePlaceholderColor: true,
                enableBackground: true,
                enableBorder: true,
                enableShadow: true
            }
        }
        case 'file': {
            if (params?.isFileUploaded) {
                return {
                    enableRadius: true,
                    enableColor: true,
                    enableIconColor: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }

            return {
                enableTheme: true,
                enableRadius: true,
                enableLabelColor: true,
                enableColor: true,
                enableIconColor: true,
                enableBackground: true,
                enableBorder: true,
                enableShadow: true
            }
        }
        case 'checkbox': {
            return {
                enableTheme: true,
                enableLabelColor: true,
                enableColor: true
            }
        }
        case 'slider': {
            if (params?.isSlider) {
                return {
                    enableColor: true,
                    enableBackground: true
                }
            }

            return {
                enableLabelColor: true,
                enableTheme: true,
                enableRadius: true,
                enableColor: true,
                enablePlaceholderColor: true,
                enableBackground: true,
                enableBorder: true,
                enableShadow: true
            }
        }

        case 'notes': {
            return {
                enableLabelColor: true,
                enableBorder: true
            }
        }

        default: {
            return undefined
        }
    }
}

export const getFieldBlockInteractionStyleLimit = (
    type: FieldInputConfigProtocol['inputType'],
    params?: GetFieldBlockLimitParams
): Partial<InteractionSettingSwitch> | undefined => {
    switch (type) {
        case 'text':
        case 'phoneNumber':
        case 'email':
        case 'url':
        case 'number':
        case 'cascade':
        case 'date': {
            return {
                hoverStyle: {
                    enableColor: true,
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true

                    // hideCheckedColor: true,
                },
                activeStyle: {
                    enableColor: true,
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true

                    // hidePlaceholderColor: true,
                    // hideCheckedColor: true,
                },
                disabledStyle: {
                    enableColor: true,
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }
        }
        case 'relativeSelect': {
            if (!params?.isSelectField) {
                if (params?.relativeSelectShowMode === 'input') {
                    if (params?.isSelectTag) {
                        return {
                            hoverStyle: {
                                enableColor: true,
                                enableIconColor: true,
                                enableRadius: true,
                                enableBackground: true,
                                enableBorder: true,
                                enableShadow: true
                            },
                            disabledStyle: {
                                enableColor: true,
                                enableIconColor: true,
                                enableRadius: true,
                                enableBackground: true,
                                enableBorder: true,
                                enableShadow: true
                            }
                        }
                    }
                    return {
                        hoverStyle: {
                            enableIconColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        },
                        activeStyle: {
                            enableIconColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        },
                        disabledStyle: {
                            enableIconColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        }
                    }
                }
                if (params?.relativeSelectShowMode === 'tag') {
                    return {
                        hoverStyle: {
                            enableColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        },
                        activeStyle: {
                            enableColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        },
                        disabledStyle: {
                            enableColor: true,
                            enableRadius: true,
                            enableBackground: true,
                            enableBorder: true,
                            enableShadow: true
                        }
                    }
                }
                if (params?.relativeSelectShowMode === 'checkbox') {
                    return {
                        hoverStyle: {
                            enableColor: true,
                            enableBackground: true,
                            enableBorder: true
                        },
                        activeStyle: {
                            enableColor: true,
                            enableCheckedColor: true,
                            enableBackground: true,
                            enableBorder: true
                        },
                        disabledStyle: {
                            enableColor: true,
                            enableBackground: true,
                            enableBorder: true
                        }
                    }
                }
                return undefined
            }
            if (params?.relativeSelectShowMode === 'input') {
                return {
                    hoverStyle: {
                        enableIconColor: true,
                        enableRadius: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    },
                    activeStyle: {
                        enableIconColor: true,
                        enableRadius: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    },
                    disabledStyle: {
                        enableIconColor: true,
                        enableRadius: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    }
                }
            }
            if (params?.relativeSelectShowMode === 'tag') {
                return
            }
            if (params?.relativeSelectShowMode === 'checkbox') {
                return {
                    hoverStyle: {
                        enableBackground: true,
                        enableBorder: true
                    },
                    activeStyle: {
                        enableBackground: true,
                        enableBorder: true,
                        enableCheckedColor: true
                    },
                    disabledStyle: {
                        enableBackground: true,
                        enableBorder: true
                    }
                }
            }
            return undefined
        }
        case 'person': {
            if (params?.isPersonTag) {
                return {
                    hoverStyle: {
                        enableColor: true,
                        enableIconColor: true
                    },
                    disabledStyle: {
                        enableColor: true,
                        enableIconColor: true
                    }
                }
            }
            return {
                hoverStyle: {
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                },
                activeStyle: {
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                },
                disabledStyle: {
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }
        }
        case 'file': {
            if (params?.isFileUploaded) {
                return {
                    hoverStyle: {
                        enableColor: true,
                        enableIconColor: true,
                        enableRadius: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    },
                    disabledStyle: {
                        enableColor: true,
                        enableIconColor: true,
                        enableRadius: true,
                        enableBackground: true,
                        enableBorder: true,
                        enableShadow: true
                    }
                }
            }
            return {
                hoverStyle: {
                    enableColor: true,
                    enableIconColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }
        }
        case 'slider': {
            if (params?.isSlider) {
                return undefined
            }
            return {
                hoverStyle: {
                    enableColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                },
                activeStyle: {
                    enableColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                },
                disabledStyle: {
                    enableColor: true,
                    enableRadius: true,
                    enableBackground: true,
                    enableBorder: true,
                    enableShadow: true
                }
            }
        }
        // case 'checkbox': {
        //     return undefined
        // }

        // case 'notes': {
        //     return undefined
        // }

        default: {
            return undefined
        }
    }
}
